import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top whenever the route path changes.
 * Place inside <Router> so it can read the current location.
 *
 * Preserves the browser's in-page anchor / hash behavior by ignoring
 * changes that only affect the hash.
 */
const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there is a hash, let the browser handle the anchor jump instead.
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
